import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import {
  Box,
  Card,
  ClickAwayListener,
  Divider,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import _ from "lodash";
import { useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import unlimitedPlanDiscount from "../../../config/discountCouponMNM.json";
import EnvConfig from "../../../config/env.config.json";
import { RoutingURLs } from "../../../config/RoutingURLs";
import { planModalType, SimTypes } from "../../../features/checkout/Types";
import {
  GetCurrencyFixed,
  GetCurrencyFixedToTwo,
} from "../../../utils/commonFunctions/GetCurrencyFixedToTwo";
import { gtmTagManager } from "../../../utils/commonFunctions/GtmTagManager";
import {
  caclulatePlanCostBasedOnEligibility,
  isLandingPage,
  isPromotionalLandingPage,
  promotionalLandingPagePlanName,
  renderTextStyles,
} from "../../../utils/commonFunctions/ReusableFunctions";
import { NutritionLabel } from "../../home/PlanCard/NutritionLabel/NutritionLabel";
import { ButtonCust, CustToolTip, SimpleModal } from "../../widgets";
import { AddLine_ChangePlanTemplateProps } from "./AddLine_ChangePlan";
import { calculateUnlimitedCost } from "../../home/PlanCard/PlanCardsComponent";
import { Coupon } from "../../../features/checkout/checkoutSlice";
import { updateCartPayload } from "../../../utils";
import {
  addCartItems,
  deleteCartItems,
  getCartItems,
  updateCartItems,
} from "../../../features/shopWare/shopWareSlice";
const T3_AddLine_ChangePlan = (props: AddLine_ChangePlanTemplateProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const {
    isShowModal,
    modalType,
    setOpenModal,
    plandata,
    index,
    formik,
    handleChangePlan,
    handleAddLine,
    content,
    currentPlan,
    amendedReachPlanId,
    initialCount = 0,
    isEsim,
    currentLine,
  } = props;
  const { heading1, heading2 } = content;

  const {
    current_plan,
    per_month_text,
    discount_text,
    tax_text,
    btn_txt,
    data,
    dollar,
    hd_vid,
    sd_vid,
    broadBandFacts,
    amendedPlan_desc,
    bundled_text,
    featureTextColor,
    throttle_speed,
    hotspot_data,
  } = content.plan_features || {};
  const { tick_icon, mbl_img, video_img, tet_img, throttle_img } = content;
  let { coupon } = useAppSelector((state: any) => state.checkout);
  const dispatch = useAppDispatch();

  if (!coupon && isLandingPage()) {
    const lpdata = localStorage.getItem("landingPageConfigData");
    const storedConfigData = lpdata && JSON.parse(lpdata);
    dispatch(
      Coupon({
        couponCode: storedConfigData?.promo?.coupon,
      })
    );
  }
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const { globalVal } = useAppSelector(
    (state: any) => state?.strapi?.globalValues || {}
  );
  let details: any = localStorage.getItem("customerDetail");
  details = JSON.parse(details);
  const [nutritionLabel, setNutritionLabel] = useState({
    show: false,
    name: "",
  });

  const selectPlanHandler = (newPlan: any) => {
    if (modalType === planModalType.changePlan) {
      handleChangePlan(index, newPlan);
    } else if (modalType === planModalType.addLine) {
      handleAddLine(index, newPlan);
    }
    onClose();
  };

  const onClose = () => {
    setOpenModal(false);
  };

  const calculateUnlimitedCostMnM = (
    data: any,
    selectedLine: any,
    isRounded: boolean = true
  ) => {
    const SELECTED_LINE = selectedLine;

    let planCost = 0;
    let planPerLinesCost = 0;
    if (data?.addLineSplitPrice) {
      let linePrice1 = 0;
      for (let i = 1; i <= SELECTED_LINE - 1; i++) {
        linePrice1 = linePrice1 + data?.addLineSplitPrice[i];
      }
      planCost =
        ((100 - data?.discountPctg) * data?.baseLinePrice) / 100 + linePrice1;
      planPerLinesCost = planCost / SELECTED_LINE;
    } else {
      planCost =
        ((100 - data?.discountPctg) * data?.baseLinePrice) / 100 +
        (SELECTED_LINE - 1) * data?.additionalLinePrice;
      planPerLinesCost = planCost / SELECTED_LINE;
    }
    if (isRounded) {
      planCost = Math.ceil(planCost);
      planPerLinesCost = Math.ceil(planPerLinesCost);
    }
    return {
      planCost,
      planPerLinesCost,
    };
  };
  const calculateCost = (
    data: any,
    selectedLine: any,
    isRounded: boolean = true
  ) => {
    const SELECTED_LINE = selectedLine;
    const planCost =
      ((100 - data?.discountPctg) * data?.baseLinePrice) / 100 +
      (SELECTED_LINE - 1) * data?.additionalLinePrice;
    let planPerLinesCost = 0;
    if (isRounded) planPerLinesCost = Math.ceil(planCost / SELECTED_LINE);
    else planPerLinesCost = planCost / SELECTED_LINE;
    return {
      planCost,
      planPerLinesCost,
    };
  };
  const priceCalculationHandler: any = (
    data: any,
    selectedLine: any = 1,
    coupon: any
  ) => {
    if (coupon?.discountInDollar) {
      return data?.baseLinePrice - (coupon?.discountInDollar || 0);
    } else {
      return data?.baseLinePrice;
    }
    // let PlanDiscountCost, planPerLinesCost: any;
    // if (data.isUnlimited) {
    //   const { planCost } = calculateUnlimitedCostMnM(data, selectedLine, false);
    //   PlanDiscountCost = caclulatePlanCostBasedOnEligibility(
    //     planCost,
    //     unlimitedPlanDiscount.data[0].discountInDollar * selectedLine
    //   );
    // } else {
    //   const { planCost } = calculateCost(data, selectedLine);
    //   PlanDiscountCost = caclulatePlanCostBasedOnEligibility(
    //     planCost,
    //     unlimitedPlanDiscount.data[0].discountInDollar * selectedLine
    //   );
    // }
    // planPerLinesCost = PlanDiscountCost / selectedLine;
    // return planPerLinesCost;
  };

  const PoperOver = (data: any) => {
    return (
      <ClickAwayListener
        onClickAway={() => {
          setAnchorEl(null);
        }}
      >
        <Box
          component="a"
          target="_blank"
          sx={{
            color: "var(--white)",
            fontSize: "14px",
            backgroundColor: "var(--navy)",
          }}
        >
          {data}
        </Box>
      </ClickAwayListener>
    );
  };

  return (
    <SimpleModal
      isShowModal={isShowModal}
      onCloseModal={onClose}
      showClose={true}
      sx={{
        boxShadow:
          "0px 0px 2px 0px rgba(79, 94, 113, 0.12), 0px 2px 4px 0px rgba(79, 94, 113, 0.11), 0px 4px 8px 0px rgba(79, 94, 113, 0.10), 0px 8px 16px 0px rgba(79, 94, 113, 0.09), 0px 16px 32px 0px rgba(79, 94, 113, 0.08), 0px 32px 64px 0px rgba(79, 94, 113, 0.07)",
        borderRadius: "9px",
        width: {
          xs: "90%",
          xl: "100% !important",
          sm: "100% !important",
          md: "100% !important",
          lg: "100% !important",
        },
        maxWidth: { xl: "1093px" },
      }}
    >
      <Typography sx={renderTextStyles(1, "24px", "title-color_1", "36px")}>
        {modalType === planModalType.changePlan ? heading1 : heading2}
      </Typography>
      <Box
        sx={{
          display: { xs: "flex", md: "flex" },
          justifyContent: { xs: "flex-start", md: "center" },
          overflow: { xs: "scroll", sm: "initial" },
          flexWrap: { xs: "nowrap", sm: "wrap" },
          m: "20px auto 0px",
          p: "4px 4px 20px",
          gap: { xs: "20px", sm: "25px" },
          width: "100%",
        }}
      >
        {plandata?.map((p: any, i: any) => {
          const { planCost, planPerLinesCost } = p?.unlimited
            ? calculateUnlimitedCost(p, 1)
            : calculateCost(p, 1);
          const isCurrentPlan =
            details?.reachPlanDisplayName === p?.displayName;
          // const planPerLinesCost = priceCalculationHandler(p);

          //change plan condition for landing page
          let changePlanCondition = true;
          if (isLandingPage()) {
            changePlanCondition =
              !isLandingPage() ||
              p?.displayName === promotionalLandingPagePlanName()?.name ||
              promotionalLandingPagePlanName()?.name === "All Plan";
          } else if (isPromotionalLandingPage()) {
            changePlanCondition =
              !isPromotionalLandingPage() ||
              p.displayName === EnvConfig.LANDINGPAGE_PLAN;
          }
          return (
            changePlanCondition && (
              <Card
                id={`home${index}`}
                key={p.displayName}
                raised
                elevation={isMobile ? 0 : 8}
                sx={{
                  borderRadius: "14px",
                  minWidth: "235px",
                  p: "20px 0px 5px",
                  width: "15%",
                  boxShadow: "none !important",
                  overflow: {
                    xs:
                      nutritionLabel.show && nutritionLabel.name === p?.name
                        ? "scroll"
                        : "revert",
                    sm:
                      nutritionLabel.show && nutritionLabel.name === p?.name
                        ? "scroll"
                        : "unset",
                  },
                  position: {
                    xs:
                      modalType === planModalType.changePlan &&
                      currentPlan?.displayName === p.displayName
                        ? "relative"
                        : "initial",
                    sm: "unset",
                  },
                  border:
                    modalType === planModalType.changePlan &&
                    currentPlan?.displayName === p.displayName
                      ? "1px solid var(--primary_color)"
                      : "1px solid var(--plan_card_border_color)",
                  height:
                    nutritionLabel.show && nutritionLabel.name === p?.name
                      ? "400px"
                      : "400px",
                  maxHeight: "400px",
                  "&::-webkit-scrollbar": {
                    display: "none",
                  },
                  "&-ms-overflow-style:": {
                    display: "none",
                  },
                }}
              >
                {modalType === planModalType.changePlan &&
                currentPlan?.displayName === p.displayName ? (
                  <Box
                    sx={{
                      mt: { xs: "-8px", sm: "-32px" },
                      display: "flex",
                      justifyContent: "center",
                      width: "100%",
                      pb: "32px",
                      position: { xs: "absolute", sm: "unset" },
                    }}
                  >
                    <Typography
                      component="div"
                      sx={{
                        backgroundColor: "var(--white)",
                        position: "absolute",
                        display: "flex",
                        alignItems: "center",
                        top: { xs: "-20px", sm: "unset" },
                        gap: "2px",
                        px: "5px",
                      }}
                    >
                      <Box
                        component="img"
                        alt={tick_icon?.data?.attributes?.alternativeText}
                        src={tick_icon?.data?.attributes?.url || ""}
                        width="17px"
                      />
                      <Typography
                        component="span"
                        sx={_.merge(
                          renderTextStyles(3, "14px", "medium-green", "21px"),
                          {
                            fontStyle: "italic",
                          }
                        )}
                      >
                        {current_plan}
                      </Typography>
                    </Typography>
                  </Box>
                ) : null}
                <Typography
                  component={"h5"}
                  sx={{
                    fontFamily: "var(--font_family_Semibold)",
                    fontSize: { xs: "20px", md: "18px" },
                    color: "var(--text_color_12)",
                    fontWeight: "600",
                    my: "6px",
                    textAlign: "center",
                  }}
                >
                  {p.displayName}
                </Typography>
                <Box sx={{ textAlign: "center", minHeight: "230px" }}>
                  <Typography
                    component={"span"}
                    sx={{
                      fontSize: "32px",
                      fontFamily: "var(--font_family_Bold)",
                      // color: "var(--primary_color)",
                    }}
                  >
                    <Typography
                      component={"span"}
                      sx={{
                        fontSize: "20px",
                        fontFamily: "var(--font_family_Bold)",
                        fontWeight: "var(--font_weight_5) !important",
                        color: "inherit",
                      }}
                    >
                      {coupon?.discountInDollar ? (
                        <>
                          <Typography
                            component="span"
                            sx={{
                              fontFamily: "var(--font_family_Bold)",
                              fontSize: "20px",
                              color: "var(--black)",
                            }}
                          >
                            {dollar}
                          </Typography>
                          <Typography
                            component="span"
                            sx={{
                              fontFamily: "var(--font_family_Bold)",
                              fontSize: "20px",
                              color: "var(--black)",
                            }}
                          >
                            {GetCurrencyFixed(
                              planCost
                                ? planCost - (coupon?.discountInDollar || 0)
                                : 0,
                              p.currency ? p.currency : "usd",
                              true
                            )}
                          </Typography>
                          <Typography
                            component={"span"}
                            sx={{
                              fontFamily: {
                                xs: " var(--font_family_Bold)",
                                sm: "var(--font_family_Semibold)",
                              },
                              fontWeight: {
                                xs: " var(--font_weight_4)",
                                sm: "var(--font_weight_2)",
                              },
                              fontSize: { xs: "20px" },
                              color: "var(--black)",
                            }}
                          >
                            {per_month_text}
                          </Typography>
                          &nbsp;
                          <Typography
                            component="span"
                            sx={{
                              textDecoration: "line-through",
                              color: "var(--text_color_12)",
                              fontWeight: "var(--font_weight_1)",
                              fontFamily: "var(--font_family_SemiBold)",
                              fontSize: "20px",
                            }}
                          >
                            {dollar}
                          </Typography>
                          <Typography
                            component="span"
                            sx={{
                              textDecoration: "line-through",
                              color: "var(--text_color_12)",
                              fontWeight: "var(--font_weight_1)",
                              fontFamily: "var(--font_family_SemiBold)",
                              fontSize: "20px",
                            }}
                          >
                            {GetCurrencyFixed(
                              planCost ? planCost : 0,
                              p.currency ? p.currency : "usd",
                              true
                            )}
                          </Typography>
                        </>
                      ) : (
                        <>
                          <Typography
                            component="span"
                            sx={{
                              fontFamily: "var(--font_family_Bold)",
                              fontSize: "20px",
                              color: "var(--black)",
                            }}
                          >
                            {dollar}
                          </Typography>
                          <Typography
                            component="span"
                            sx={{
                              fontFamily: "var(--font_family_Bold)",
                              fontSize: "20px",
                              color: "var(--black)",
                            }}
                          >
                            {GetCurrencyFixed(
                              planCost ? planCost : 0,
                              p.currency ? p.currency : "usd",
                              true
                            )}
                          </Typography>
                          <Typography
                            component={"span"}
                            sx={{
                              fontFamily: {
                                xs: " var(--font_family_Bold)",
                                sm: "var(--font_family_Semibold)",
                              },
                              fontWeight: {
                                xs: " var(--font_weight_4)",
                                sm: "var(--font_weight_2)",
                              },
                              fontSize: { xs: "20px" },
                              color: "var(--black)",
                            }}
                          >
                            {per_month_text}
                          </Typography>
                        </>
                      )}
                    </Typography>
                    <Typography
                      component={"div"}
                      sx={{
                        fontFamily: "var(--font_family_Regular)",
                        fontSize: "12px",
                        color: "var(--text_color)",
                        my: "10px",
                      }}
                    >
                      {tax_text}
                    </Typography>
                    {/* {bundled_text && (
                    <Typography
                      component={"div"}
                      sx={{
                        fontFamily: "var(--font_family_Regular)",
                        fontSize: "12px",
                        color: "var(--black)",
                        my: "10px",
                      }}
                    >
                      {bundled_text}
                    </Typography>
                  )} */}
                  </Typography>
                  <Typography
                    component={"span"}
                    sx={{
                      display: "flex",
                      justifyContent: "left",
                      alignItems: "center",
                      pl: "25px",
                      my: "15px",
                    }}
                  >
                    <Box
                      component="img"
                      alt={mbl_img?.data?.attributes?.alternativeText}
                      src={mbl_img?.data?.attributes?.url || ""}
                      width="15px"
                    />
                    <Typography
                      component={"span"}
                      sx={{
                        fontFamily: "var(--font_family_Regular)",
                        fontSize: "13px",
                        color: "var(--button_secondary_color)",
                        ml: "15px",
                      }}
                    >
                      {p.planData + p.dataUnit + " " + (data ?? "")}
                    </Typography>
                  </Typography>
                  <Typography
                    component={"span"}
                    sx={{
                      display: "flex",
                      justifyContent: "left",
                      alignItems: "center",
                      pl: "25px",
                      my: "15px",
                    }}
                  >
                    <Box
                      component="img"
                      alt={video_img?.data?.attributes?.alternativeText}
                      src={video_img?.data?.attributes?.url || ""}
                      width="15px"
                    />
                    <Typography
                      component={"span"}
                      sx={{
                        fontFamily: "var(--font_family_Regular)",
                        fontSize: "13px",
                        color: "var(--button_secondary_color)",
                        ml: "15px",
                      }}
                    >
                      {p.streamType === "HD" ? hd_vid : sd_vid}
                    </Typography>
                  </Typography>
                  {p?.tethering && (
                    <Typography
                      component={"span"}
                      sx={{
                        display: "flex",
                        justifyContent: "left",
                        alignItems: "center",
                        pl: "25px",
                        my: "17px",
                      }}
                    >
                      <Box
                        component="img"
                        alt={tet_img?.data?.attributes?.alternativeText}
                        src={tet_img?.data?.attributes?.url || ""}
                        width="15px"
                      />
                      <Typography
                        component={"span"}
                        sx={{
                          fontFamily: "var(--font_family_Regular)",
                          fontSize: "13px",
                          color: featureTextColor
                            ? featureTextColor
                            : "var(--title-color_1)",
                          ml: "15px",
                        }}
                      >
                        {p?.tethering}
                        {hotspot_data}
                      </Typography>
                    </Typography>
                  )}
                  {p?.throttleSpeed > 0 ? (
                    <Typography
                      component={"span"}
                      sx={{
                        display: "flex",
                        justifyContent: "left",
                        alignItems: "center",
                        pl: "25px",
                        my: "18px",
                      }}
                    >
                      <Box
                        component="img"
                        alt={throttle_img?.data?.attributes?.alternativeText}
                        src={throttle_img?.data?.attributes?.url || ""}
                        width="15px"
                      />
                      <Typography
                        component={"span"}
                        sx={{
                          fontFamily: "var(--font_family_Regular)",
                          fontSize: "13px",
                          color: featureTextColor
                            ? featureTextColor
                            : "var(--title-color_1)",
                          ml: "15px",
                        }}
                      >
                        {p?.throttleSpeed}&nbsp;{p?.throttleSpeedUnit}&nbsp;
                        {throttle_speed}
                      </Typography>
                    </Typography>
                  ) : null}
                </Box>
                {!currentLine?.reachPlanChangeDate &&
                amendedReachPlanId === p.name ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        padding: "5px",
                        margin: "15px 0px",
                        backgroundColor: "var(--light_primary_color)",
                      }}
                    >
                      <CustToolTip
                        title={PoperOver(
                          <>
                            <Typography
                              sx={{
                                fontWeight: "var(--font_weight_1)",
                                fontSize: "12px",
                                fontFamily: "var(--font_family_Medium)",
                                lineHeight: "21px",
                                "& span": {
                                  fontWeight: "var(--font_weight_2)",
                                  fontFamily: "var(--font_family_Semibold)",
                                },
                              }}
                              dangerouslySetInnerHTML={{
                                __html: amendedPlan_desc,
                              }}
                            />
                          </>
                        )}
                        open={anchorEl === data.id ? true : false}
                        disableFocusListener
                        disableHoverListener
                        disableTouchListener
                        arrow
                        placement="top-start"
                        sx={{
                          width: "390px",
                          color: " var(--white) !important",

                          "& .MuiTooltip-tooltip": {
                            fontFamily: "var(--font_family_Medium) !important",
                            color: " var(--white)",
                            backgroundColor: "var(--primary_color) !important",
                            padding: " 15px !important",
                            "a > p": {
                              fontFamily:
                                " var(--font_family_Medium) !important",
                              fontSize: "14px",
                            },
                          },

                          "& .MuiTooltip-arrow": {
                            "::before": {
                              backgroundColor:
                                "var(--primary_color) !important",
                            },
                          },
                        }}
                        // className={tooltip_style}
                        PopperProps={{
                          modifiers: [
                            {
                              name: "offset",
                              options: {
                                offset: [0, 10],
                              },
                            },
                          ],
                        }}
                      >
                        <Box
                          component="img"
                          alt={
                            content?.info_icon?.data?.attributes
                              ?.alternativeText
                          }
                          src={content?.info_icon?.data?.attributes?.url}
                          onMouseEnter={() => {
                            setAnchorEl(data.id);
                          }}
                          sx={{
                            width: "10px",
                            height: "10px",
                            marginRight: "10px",
                          }}
                          onMouseLeave={() => {
                            setAnchorEl(null);
                          }}
                        ></Box>
                      </CustToolTip>
                      <Typography
                        sx={{
                          fontSize: "10px",
                          color: "var(--primary_color)",

                          fontWeight: "var(--font_weight_1)",
                          textAlign: "center",
                          width: "fit-content",
                          maxWidth: "130px",
                          fontFamily: "var(--font_family_Medium)",
                        }}
                      >
                        {content?.plan_features?.new_plan_update}
                      </Typography>
                    </Box>
                  </Box>
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      my: "15px",
                    }}
                  >
                    <ButtonCust
                      variantType={EnvConfig.PRIMARY_BUTTON_TYPE}
                      data-testid="selectPlanHandler"
                      onClick={(e: any) => {
                        selectPlanHandler(p);
                        let eventPrefix =
                          location.pathname === RoutingURLs.checkout
                            ? globalVal?.gtmEvents?.changeSelectPlan
                            : location.pathname === RoutingURLs.activation
                            ? isEsim
                              ? "mobile_dashboard_esim_"
                              : "mobile_dashboard_psim_"
                            : "";
                        gtmTagManager({
                          event: `${eventPrefix}${p.planData}${p.dataUnit}_select_plan`,
                          click_section: "checkout",
                        });
                      }}
                      sx={{
                        minWidth: "200px !important",
                        "&:disabled": {
                          backgroundColor: "var(--primary_color) !important",
                          opacity: "30%",
                          border: "none !important",
                          minWidth: "200px !important",
                        },
                      }}
                      disabled={
                        modalType === planModalType.changePlan &&
                        (currentPlan?.displayName === p.displayName ||
                          (!currentLine?.reachPlanChangeDate &&
                            amendedReachPlanId === p.name))
                          ? true
                          : false
                      }
                    >
                      {btn_txt}
                    </ButtonCust>
                  </Box>
                )}
                <Divider
                  sx={{
                    borderColor: "var(--cascading-white)",
                    borderWidth: "0.5px",
                    mb: "10px",
                    // mx: { xs: "-10px", sm: "-10px" },
                  }}
                />
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    mx: "auto",
                    gap: "2px",
                    cursor: "pointer",
                    width: "max-content",
                  }}
                  onClick={() => {
                    setNutritionLabel((prevState) => ({
                      ...prevState,
                      show: prevState.show
                        ? nutritionLabel.name === p?.name
                          ? false
                          : true
                        : true,
                      name: p?.name,
                    }));
                  }}
                >
                  <Typography
                    component={"span"}
                    sx={_.merge(
                      renderTextStyles(2, "14px", "primary_color", "21px"),
                      {
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }
                    )}
                  >
                    {broadBandFacts}
                  </Typography>
                  {nutritionLabel.show ? (
                    nutritionLabel.name === p?.name ? (
                      <KeyboardArrowUp sx={{ color: "var(--primary_color)" }} />
                    ) : (
                      <KeyboardArrowDown
                        sx={{ color: "var(--primary_color)" }}
                      />
                    )
                  ) : (
                    <KeyboardArrowDown sx={{ color: "var(--primary_color)" }} />
                  )}
                </Box>
                {nutritionLabel.show && nutritionLabel.name === p?.name ? (
                  <NutritionLabel
                    {...{
                      plandata,
                      priceCalculationHandler,
                    }}
                    nlPlan={p}
                    selectedLine={1}
                  />
                ) : null}
              </Card>
            )
          );
        })}
      </Box>
    </SimpleModal>
  );
};
export default T3_AddLine_ChangePlan;
